import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { de } from './de';

const resources = { de: { translation: de } };

declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: 'translation';
    resources: (typeof resources)['de'];
  }
}

void i18next.use(initReactI18next).init({
  lng: 'de',
  fallbackLng: 'de',
  resources,
  interpolation: { escapeValue: false },
});

export { i18next };
